import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, indexedDBLocalPersistence, initializeAuth } from 'firebase/auth';

// These keys identify the project; they are not secrets. Access is enforced by
// Firebase Security Rules (see /firebase/*.rules) and server-side checks.
const firebaseConfig = {
  apiKey: 'AIzaSyAahOlYKX1JNKMEA8aj5l_u4uLdpdNRe4g',
  authDomain: 'plasticanalytics-ada31.firebaseapp.com',
  databaseURL: 'https://plasticanalytics-ada31-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'plasticanalytics-ada31',
  storageBucket: 'plasticanalytics-ada31.appspot.com',
  messagingSenderId: '917872845779',
  appId: '1:917872845779:web:923c9455e50ec381edc526',
};

// Only the app and sign-in state load on every page. Firestore, Storage, Realtime Database and
// Functions live in their own modules (db.js, fileStorage.js, rtdb.js, api.js) so they download
// only on the pages that use them — a much smaller first load on slow connections.
// The popup helper for Google sign-in is passed in on the sign-in pages only (authFlows.js).
//
// Firebase Analytics is deliberately NOT initialised here. Analytics loads only after the
// visitor opts in (see lib/analytics.js).
export const app = initializeApp(firebaseConfig);
export const auth = initializeAuth(app, { persistence: [indexedDBLocalPersistence, browserLocalPersistence] });
